import NewsBarDesktop from "@components/NewsBar/NewsBarDesktop";
import { useWindowSize } from "@hooks/useWindowSize";
import { cn } from "@util/helpers";

import type { NewsBarProps } from "./utils/types";

/**
 * The news bar component, which displays a list of articles and a label.
 * GA trackings are currently hardcoded per component call, ideally this should be retrieved together with the story queue for it to be totally dynamic.
 * Right now it is not possible.
 */
const NewsBar = ({
  cardProps = [],
  className,
  mobileElement,
  label,
  eventCategory,
}: NewsBarProps): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  if (cardProps.length === 0) return <></>;

  const parameters = [{ key: "ref", value: "ge2025-newsbar" }];

  return (
    <div
      className={cn(
        "track-impression flex h-full w-full items-center justify-center rounded-[4px] border border-gray-175 bg-[#BABABA1C] px-3 lg:justify-normal lg:rounded-none lg:border-none lg:px-4",
        className
      )}
      data-testid="news-bar-component"
      data-section-name={eventCategory}
      data-section-label="news bar"
    >
      {isScreenLG ? (
        <NewsBarDesktop
          cardProps={cardProps}
          className="hidden w-full lg:flex"
          parameters={parameters}
          label={label}
          eventCategory={eventCategory}
        />
      ) : (
        <>{mobileElement}</>
      )}
    </div>
  );
};

export default NewsBar;
